import { menuBar } from 'prosemirror-menu';
import { Schema } from 'prosemirror-model';

import { decorationsMenu } from './decorations.menu';
import { historyMenu } from './history.menu';
import { imageMenu, ImageMenuOptions } from './image.menu';
import { inlineMenu, InlineMenuOptions } from './inline.menu';
import { listMenu } from './list.menu';
import { styleMenu } from './style.menu';

export interface MenuOptions extends InlineMenuOptions, ImageMenuOptions {
  simpleMenu?: boolean;
}

export function menu(schema: Schema, options: MenuOptions) {
  if (options.simpleMenu) {
    return menuBar({
      content: [inlineMenu(schema, options), styleMenu(schema)],
    });
  } else {
    return menuBar({
      content: [
        inlineMenu(schema, options),
        styleMenu(schema),
        historyMenu(),
        listMenu(schema),
        imageMenu(schema, options),
        decorationsMenu(schema),
      ],
    });
  }
}
